import firebase from 'firebase/app';
// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";
import uuid4 from "uuid4";

class FirebaseAuthBackend {
    constructor(firebaseConfig) {
        if (firebaseConfig) {
            // Initialize Firebase
            firebase.initializeApp(firebaseConfig);
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    sessionStorage.setItem("authUser", JSON.stringify(user));
                    const db = firebase.firestore();
                    db.collection('users').doc(firebase.auth().currentUser.email).get()
                    .then((doc) => {
                        if (doc.exists) {
                            console.log("user_detail:", doc.data());
                            sessionStorage.setItem("user_detail", JSON.stringify(doc.data()));
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    }).catch((error) => {
                        console.log(error)
                    });
                    db.collection('admin').doc(firebase.auth().currentUser.email).get()
                    .then((doc) => {
                        if (doc.exists) {
                            let doc_data = doc.data();
                            sessionStorage.setItem("is_user_admin", doc_data.is_admin);
                        }
                    }).catch((error) => {
                        console.log(error)
                    });
                } else {
                    sessionStorage.removeItem('authUser');
                    sessionStorage.removeItem('user_detail');
                    sessionStorage.removeItem('is_user_admin');

                }
            });
        }
    }

    /**
     * Registers the user with given details
     */
    registerUser = (email, password) => {
        return new Promise((resolve, reject) => {
            firebase.auth().createUserWithEmailAndPassword(email, password).then((user) => {
                // eslint-disable-next-line no-redeclare
                var user = firebase.auth().currentUser;
                resolve(user);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Login user with given details
     */
    loginUser = (email, password) => {
        return new Promise((resolve, reject) => {
            firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
                // eslint-disable-next-line no-redeclare
                var user = firebase.auth().currentUser;
                resolve(user);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    isUserAdmin = () => {
        return new Promise((resolve, reject) => {
            const db = firebase.firestore();
            db.collection('admin').doc(firebase.auth().currentUser.email).get()
            .then((doc) => {
                let is_admin_user = false
                if (doc.exists) {
                    const doc_data = doc.data()
                    is_admin_user = doc_data.is_admin
                }
                resolve(is_admin_user);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * forget Password user with given details
     */
    forgetPassword = (email) => {
        return new Promise((resolve, reject) => {
            firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + "//" + window.location.host + "/login" }).then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            firebase.auth().signOut().then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    /**
     * get senarai tempahan
     */
    getTempahan = (tarikh) => {
        return new Promise((resolve, reject) => {
            const db = firebase.firestore();
            db.collection("tempahan").where('tarikh', '==', tarikh).get().then((querySnapshot) => {
                resolve(querySnapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    getTempahanByID = (pathID) => {
        return new Promise((resolve, reject) => {
            const db = firebase.firestore();
            db.collection("tempahan").doc(pathID).get().then((querySnapshot) => {
                resolve(querySnapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    getTempahanPKG = (tarikh,pkg) => {
        return new Promise((resolve, reject) => {
            const db = firebase.firestore();
            db.collection("tempahan").where('tarikh', '==', tarikh).where('pkg_id', '==', pkg).get().then((querySnapshot) => {
                resolve(querySnapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    getPKG = () => {
        return new Promise((resolve, reject) => {
            const db = firebase.firestore();
            db.collection("pkg").where('status', '==', 'buka').get().then((querySnapshot) => {
                resolve(querySnapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }

    uploadMemos = (file) => {
        return new Promise((resolve, reject) => {
            const storage = firebase.storage();
            storage.ref(`memo/${file.name}`).put(file).then((snapshot) => {
                resolve(snapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    urlMemos = (file) => {
        return new Promise((resolve, reject) => {
            const storage = firebase.storage();
            storage.ref(`memo/${file.name}`).getDownloadURL(file).then((snapshot) => {
                resolve(snapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    insertTempahan = (dataTempahan) => {
        return new Promise((resolve, reject) => {
            let insData = dataTempahan;
            var idDoc = uuid4();
            insData['id'] = idDoc
            const db = firebase.firestore();
            db.collection('tempahan').doc(idDoc).set(insData)
            .then((snapshot) => {
                resolve(snapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    lulusMohon = (idDoc) => {
        return new Promise((resolve, reject) => {
            const db = firebase.firestore();
            db.collection('tempahan').doc(idDoc).update({status_permohonan: "Lulus"})
            .then((snapshot) => {
                resolve(snapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }
    tidakLulusMohon = (idDoc) => {
        return new Promise((resolve, reject) => {
            const db = firebase.firestore();
            db.collection('tempahan').doc(idDoc).update({status_permohonan: "Tidak Lulus"})
            .then((snapshot) => {
                resolve(snapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }


    setLoggeedInUser = (user) => {

        sessionStorage.setItem("authUser", JSON.stringify(user));
        var user_detail = firebase.auth().currentUser;
        const db = firebase.firestore();
        db.collection('users').doc(user_detail.email).get()
        .then((doc) => {
            if (doc.exists) {
                console.log("user_detail:", doc.data());
                sessionStorage.setItem("user_detail", JSON.stringify(doc.data()));
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch((error) => {
            console.log(error)
        });
    }

    upsertUsers = (usr_infos) => {
        return new Promise((resolve, reject) => {
            const db = firebase.firestore();
            db.collection('users').doc(firebase.auth().currentUser.email).set(usr_infos)
            .then((snapshot) => {
                sessionStorage.setItem("user_detail", JSON.stringify(usr_infos));
                resolve(snapshot);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        if (!sessionStorage.getItem('authUser'))
            return null;
        return JSON.parse(sessionStorage.getItem('authUser'));
    }
    getDetailUser = () => {
        if (!sessionStorage.getItem('user_detail'))
            return null;
        return JSON.parse(sessionStorage.getItem('user_detail'));
    }

    /**
     * Handle the error
     * @param {*} error 
     */
    _handleError(error) {
        var errorMessage = error.message;
        return errorMessage;
    }
}

let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config 
 */
const initFirebaseBackend = (config) => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend(config);
    }
    return _fireBaseBackend;
}

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
    return _fireBaseBackend;
}

export { initFirebaseBackend, getFirebaseBackend };